import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import { config } from '../../constants/domainConfig';
import { addUid } from '../../actions/WelcomeActions';
import { hideSplash } from '../../actions/SplashScreenActions';
import { checkAccess } from '../../actions/WelcomeActions';

import { show, hide } from '../../actions/ActivityIndicatorActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { addFavoriteChannel, addFavoriteVideo, addLikesChannels, addLikesVideos } from '../../actions/FavoriteActions';
import { showMessage } from '../../actions/FlashMessageActions';
import { resetBack, setHeaderTitle } from '../../actions/HeaderActions';
import { addChannelHistory, addVideoHistory, addShowHistory } from "../../actions/HistoryActions";
import { getChannels, getTVCategories, getVideos, getVideosPackages } from "../../actions/CategoryActions";
import { getDetails, getInterests } from "../../actions/AccountActions";
import * as vars from '../../constants/constants';
import { console_log, parseQueryString,getParameters} from '../../utils/helper';
import { FormattedMessage } from 'react-intl';
import {sendData} from './../../analytics/sendData'
class SplashScreen extends Component {
	constructor(props) {
        super(props);
        this.callApis=this.callApis.bind(this);
	}
    componentWillMount() {
        if (localStorage.getItem('authorized')) localStorage.removeItem('authorized');
        if (localStorage.getItem('mobiotv')) localStorage.removeItem('mobiotv');
        if(config.subDomain === 'tr' || config.subDomain === 'tr.mobiofit'){
            this.props.hideSplash();
            this.props.history.push("/login");
            return;
        }
        if (!JSON.parse(sessionStorage.getItem('authorized')) || !JSON.parse(sessionStorage.getItem('authorized')).success) {
            if (config.subDomain == "za.fun-box" && window.location.href.indexOf('terms-conditions') >= 0) {
                this.props.hideSplash();
                return;
            }
            let rid = new URL(window.location.href).searchParams.get('rid')            
            sendData(rid,'','','Landed',{status: 'success', url: window.location.href })
            const queryStrings = parseQueryString(this.props.location.search);
            if(config.subDomain === "safaricom" && (queryStrings.is_staging && queryStrings.is_staging==='true')){
                axios.get(vars.BASE_API_URL + '/checkAccessStaging?uid='+parseQueryString(this.props.location.search)['uid'])
                .then((response) => {
                    let data = {
                        success: response.data.success,
                        uid: this.props.access.uid,
                        token: response.data.data.token,
                        rockmanId: response.data.data.rockmanId
                    };
                    sessionStorage.setItem("authorized", JSON.stringify(data))
                    this.props.checkAccess(data);
                    this.props.addUid({
                        uid: parseQueryString(this.props.location.search)['uid']
                    })
                    if (response.data.success) {
                        axios.defaults.headers.common['authorization'] = response.data.data.token;
                        this.callApis()
                    } else {
                        if (config.subDomain == 'it') window.location = 'http://n.mobiotv.com/it/mix-videos?device=smart&offer=1';
                        else {
                            this.props.hideSplash();
                            this.props.history.push("/login");
                        }
                    }
                })
                .catch((error) => {
                    console_log(error);
                });
            }
        else if(rid || parseQueryString(this.props.location.search)['rid']){
                this.props.show()
                var rid_found = parseQueryString(this.props.location.search)['rid'] || rid;
                axios.get(vars.BASE_API_URL + `/checkAccess?uid=${rid_found}`)
                .then((response) => {
                    this.props.hideSplash()
                    if(response.data.success){
                        let data = {
                            success: response.data.success,
                            uid: response.data.data.rockmanId,
                            token: response.data.data.token,
                            rockmanId: response.data.data.rockmanId
                        }
                        sessionStorage.setItem("authorized", JSON.stringify(data))
                        this.props.checkAccess(data);
                        axios.defaults.headers.common['authorization'] = response.data.data.token;
                        sendData(data.rockmanId, '', '', 'Accessed', { method: 'rid', status: 'success', url: window.location.href});
                        this.callApis()
                        this.props.addUid({
                            uid: data.uid || rid_found
                        })
                        let to = `/home?uid=${data.uid || rid_found}`;
                        this.props.history.push(to);
                    }
                    else{
                        sendData(rid, '', '', 'Failed', { method: 'msisdn', status: 'failure', url: window.location.href});
                        this.props.hide();
                        this.props.history.push("/login");
                    }
                })
                .catch((error) => {
                    this.props.hideSplash();
                    this.props.history.push("/login");
                });
            }
            else if (parseQueryString(this.props.location.search)['msisdn']) {
                this.props.show();
                if(config.subDomain === 'tr') {
                    this.props.hideSplash();
                    this.props.history.push("/login")
                }
                else{
                    axios.get(vars.BASE_API_URL + `/checkAccessWithMsisdn?msisdn=${parseQueryString(this.props.location.search)['msisdn']}&domain=${window.location.hostname.includes("localhost") ? 'ae.mobiofit.com' : window.location.hostname}`)
                    .then((response) => {
                        this.props.hideSplash();
                        if (response.data.success) {
                            let data = {
                                success: response.data.success,
                                uid: response.data.data.uid,
                                token: response.data.data.token,
                                rockmanId: response.data.data.rockmanId
                            };
                            sessionStorage.setItem("authorized", JSON.stringify(data))
                            this.props.checkAccess(data);
                            this.props.addUid({
                                uid : data.uid
                            });
                            axios.defaults.headers.common['authorization'] = response.data.data.token;
                            sendData(data.rockmanId, '', '', 'Accessed', { method: 'msisdn', status: 'success', url: window.location.href});
                            this.callApis()
                            let to = `/home?uid=${data.uid}`;
                            this.props.history.push(to);
                        }
                        else {
                            sendData(rid, '', '', 'Failed', { method: 'msisdn', status: 'failure', url: window.location.href});
                            this.props.hide();
                            this.props.history.push("/login");
                        }
                        
                    })
                    .catch((error) => {
                        this.props.hideSplash();
                        this.props.history.push("/login");
                    });
                }
            }
            else if (parseQueryString(this.props.location.search)['uid']) {
                if(config.subDomain === 'tr' && !window.location.host.includes('localhost') ){
                    this.props.hideSplash();
                    this.props.history.push("/login")
                }
                else{
                    axios.get(vars.BASE_API_URL + '/checkAccess?uid=' + parseQueryString(this.props.location.search)['uid'] + '&domain=' + `${window.location.hostname.includes("localhost") ? 'ae.mobiofit.com' : window.location.hostname}`)
                    .then((response) => {
                        let data = {
                            success: response.data.success,
                            uid: this.props.access.uid,
                            token: response.data.data.token,
                            rockmanId: response.data.data.rockmanId
                        };
                        sessionStorage.setItem("authorized", JSON.stringify(data))
                        this.props.checkAccess(data);
                        this.props.addUid({
                            uid : data.uid
                        });
                        sendData(data.rockmanId, '', '', 'Accessed', { method: 'uid', status: 'success', url: window.location.href});
                        if (response.data.success) {
                            axios.defaults.headers.common['authorization'] = response.data.data.token;
                            this.callApis()
                        } else {
                            sendData(rid, '', '', 'Failed', { method: 'uid', status: 'failure', url: window.location.href});
                            if (config.subDomain == 'it') window.location = 'http://n.mobiotv.com/it/mix-videos?device=smart&offer=1';
                            else {
                                this.props.hideSplash();
                                this.props.history.push("/login");
                            }
                        }
                    })
                    .catch((error) => {
                        console_log(error);
                    });
                }
            }
            else{
                if (config.subDomain == "za.fun-box" && window.location.href.indexOf('terms-conditions') >= 0) {
                    this.props.hideSplash();
                    return;
                }
                else {
                    this.props.hideSplash();
                    this.props.history.push("/login");
                }    
            }
        }
        else{
            this.props.hideSplash();
            if(this.props.location.pathname==='/'){
                let uid = JSON.parse(sessionStorage.getItem('authorized')).success ? JSON.parse(sessionStorage.getItem('authorized')).uid : parseQueryString(this.props.location.search)['uid']
                this.props.history.push(`/home?uid=${uid}`);
            }else{
                this.props.history.push(this.props.location.pathname+this.props.location.search);
            }
        }
    }
    callApis(){
        if (this.props.account.interests.length <= 0) {
            this.props.show();
            setTimeout(() => {
                this.props.hide();
            }, 1500);
                axios.all([axios.get(vars.BASE_API_URL + '/interests'), axios.get(vars.BASE_API_URL + '/categories'), axios.get(vars.BASE_API_URL + '/favorites'), axios.get(vars.BASE_API_URL + '/history'), axios.get(vars.BASE_API_URL + '/likes')])
                            .then(axios.spread(( interests, categories, favorites, history, likes) => {
                               
                                // for interests
                                if (interests.data.data) {
                                    this.props.getInterests(interests.data.data);
                                }

                                // for channel categories
                                if (categories.data.data) {
                                    this.props.getTVCategories(categories.data.data);
                                }

                                // for favorites
                                if (favorites.data.data) {
                                    this.props.addFavoriteChannel(favorites.data.data.channels);
                                    this.props.addFavoriteVideo(favorites.data.data.videos);
                                }

                                // for history
                                if (history.data.data) {
                                    this.props.addChannelHistory(history.data.data.channels);
                                    this.props.addVideoHistory(history.data.data.videos);
                                    this.props.addShowHistory(history.data.data.shows);
                                }

                                // for likes
                                if (likes.data.data) {
                                    this.props.addLikesChannels(likes.data.data.channels);
                                    this.props.addLikesVideos(likes.data.data.videos);
                                }
                                if( interests.data.data && favorites.data.data && history.data.data && likes.data.data){
                                    // this.props.hideSplash();
                                }

                            }))
                            .then(() => {
                                axios.get(vars.BASE_API_URL + '/getUserProfile')
                                    .then(userProfile => {
                                        if (userProfile.data.data) {
                                            this.props.getDetails(userProfile.data.data);
                                            
                                        }
                                    })
                                    .catch(err => {
                                        console.log('error in fetching user profile ----------', err);
                                    })
                                this.props.hideSplash();
                            })
                            .catch(err => {
                                console_log(err);
                            });
                if (this.props.location.pathname === '/') {
                    this.props.history.push(`/home?uid=${parseQueryString(this.props.location.search)['uid']}`);
                } else {
                    this.props.history.push(this.props.location.pathname + this.props.location.search);
                }
            // }
        }
    }

	componentDidMount() {
		this.props.addUid({
            uid : parseQueryString(this.props.location.search)['uid']
        });
	}

	render() {
		let className = "splash-screen";
		if (this.props.splash.hideSplash) {
            className += " hidden";
		}
		return (
			<div className={config.subDomain.includes('mobiofit')? `${className} splash-screen-mobiofit`:className}>
				<div className="splash-screen__image-wrap">
                    {config.title == 'bidiotv' && config.mainDomain != 'mobiotv' ? <img className="splash-screen__image img-fluid" src="./img/logo/bidiotv-logo.png" alt="MobioTV" />
                      :  <img className={`splash-screen__image img-fluid ${config.newDomain === 'mobiofitplus' ? 'mobiofitplus-img':''}`} src={config.newDomain === 'telemovil' ? "./img/telemovil.png" : config.newDomain === 'trendme' ? "./img/trendme.png" : config.newDomain === 'fun-box' ? "./img/funbox.svg" : config.newDomain === 'vidflixz' ? "./img/vidflixz.png" : config.newDomain === 'flamilingo' ? "./img/flamilingo.png" : config.newDomain === 'fitness-bay' ? "./img/fitness-bay.png" : config.newDomain === 'mobiofitplus'? "./img/mobiotfit.png": config.subDomain.includes('mobiofit')? "./img/logo/mobiofitlogo.svg" : "./img/logo.png"} alt="MobioTV" />
                    }
				</div>
                {config.language == 'spanish' ? <p className="splash-screen__text">Ve videos sin límite</p> :

				<p className="splash-screen__text">
                        {config.subDomain==='iq.mobiofit'?
                        <FormattedMessage id="World"
                        defaultMessage="A New World of Mobiletainment"
                    />:
                    <FormattedMessage id="aNewWorld"
                            defaultMessage="A New World of Mobiletainment"
                        />}
                </p>}
                <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px', marginTop: '1rem'}}>
                    <img src="./img/tail-spin.svg" alt="Loading..." width="30" />
                </div>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        smartTV: state.SmartTVReducer,
		splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
		hideSplash,
        checkAccess,
        addUid,
        getVideoOrChannelRelatedData,
        showMessage,
        getDetails,
        getInterests,
        getVideosPackages,
        getVideos,
        getTVCategories,
        getChannels,
        addFavoriteChannel,
        addFavoriteVideo,
        setHeaderTitle,
        resetBack,
        addChannelHistory,
        addVideoHistory,
        addShowHistory,
        addLikesChannels,
        addLikesVideos,
        show,
        hide
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SplashScreen);


// WEBPACK FOOTER //
// ./src/components/SplashScreen/SplashScreen.js